import React from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../../../AxiosInstance";
import { alertError } from "../../Helper/Alerts";
import OtherPageHeader from "../../../components/OtherHeader";
import { useState } from "react";
import { useEffect } from "react";
const AddPolicy = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  useEffect(() => {
    getUserMe();
  });
  const getUserMe = () => {
    const url = "/user/me";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        if (resp.status === 200) {
          setFirstName(resp.data.firstName);
          localStorage.setItem(
            "username",
            resp.data.firstName + " " + resp.data.lastName
          );
        }
      });
  };
  return (
    <div>
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="navbar-light"
      />
      <section className="section-preview py-3">
        <div className="container">
          <div className="d-flex justify-content-center mx-1">
            <div className="tre_box-wrap text-center">
              <p className="pb-1 mb-1 tre_text-gray text-muted">
                Welcome {firstName}!
              </p>
              <h4 className="font-24 text-black tre_font-bold mb-3">
                {" "}
                Add your First Policy
              </h4>
              <div
                className="tre_policyBox mx-auto tre_flex-hcenter"
                onClick={() => navigate("/myPolicy")}
              >
                <div className="tre_policy-btn text-center">
                  <i className="fa-solid fa-plus tre_flex-hcenter mt-3 mx-auto my-2 text-white tre_plus-icons"></i>
                  <div className="tre_policy-txt tre_textpurple">
                    Add Policy
                  </div>
                </div>
              </div>
              <h3 className="font-24 text-black tre_font-bold my-4 text-center">
                Add your Life Insurance Policy details and let the journey begin!
              </h3>
              <p className="text-muted">
                Policy details filled correctly will facilitate smooth and swift
                service
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddPolicy;
